import { useEffect, useState } from "react";

import precision from "../assets/PARTNERS_LOGO/ctecfav.png";
import ethiopian from "../assets/PARTNERS_LOGO/Ethiopian_Airlines_Logo.svg.png";
import bayview from "../assets/PARTNERS_LOGO/images.png";
import liquid from "../assets/PARTNERS_LOGO/logo_LIQUID.png";
import schneider from "../assets/PARTNERS_LOGO/Schneider-Electric-logo-jpg_16-9_white.png";
import techno from "../assets/PARTNERS_LOGO/Techno-Switch.png";
import yas from "../assets/PARTNERS_LOGO/Yas_Tanzania.svg-4.png";

const clients = [
  { id: 1, name: "Precision Builders", logo: precision },
  { id: 2, name: "RT Alkin 1", logo: ethiopian },
  { id: 3, name: "Bayview Construction", logo: bayview },
  { id: 4, name: "RT Alkin 2", logo: liquid },
  { id: 5, name: "RT Alkin 3", logo: schneider },
  { id: 6, name: "Complet Home 1", logo: techno },
  { id: 7, name: "Complet Home 2", logo: yas },
];

const ClientsPartners = () => {
  const [index, setIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(5);

  // Update visibleCount based on screen width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) setVisibleCount(3); // xs
      else if (window.innerWidth < 768) setVisibleCount(3); // sm
      else if (window.innerWidth < 1024) setVisibleCount(5); // md
      else setVisibleCount(5); // lg+
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto slide every 3s
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % (clients.length - visibleCount + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [visibleCount]);

  return (
    <section className="w-full py-12 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4">
        {/* Heading */}
        <div className="mb-10 text-left">
          <h2 className="relative text-5xl md:text-7xl font-extrabold text-orange-200 uppercase opacity-30">
            CLIENTS & PARTNERS
          </h2>
          <div className="relative -mt-10">
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800">
              Clients & <span className="text-orange-600">Partners</span>
            </h3>
            <p className="mt-2 text-gray-500">
              Trust us to provide innovative solutions and outstanding service, helping your businesses grow and succeed.
            </p>
          </div>
        </div>

        {/* Logos carousel */}
        <div className="relative w-full overflow-hidden">
          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${index * (100 / visibleCount)}%)` }}
          >
            {clients.map((client) => (
              <div
                key={client.id}
                style={{ flex: `0 0 ${100 / visibleCount}%` }}
                className="flex items-center justify-center p-4"
              >
                <div className="bg-white shadow rounded-lg border p-4 hover:scale-110 transition-transform duration-300">
                  <img
                    src={client.logo}
                    alt={client.name}
                    className={`object-contain transition duration-300 ${visibleCount <= 3 ? "max-h-24" : "max-h-12"
                      }`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsPartners;
